import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    MessageScrollerStackBehaviour
} from "../../type";

export const MESSAGE_SCROLLER_STACK_JUSTIFICATIONS: Record<MessageScrollerStackBehaviour, ViewStyle["justifyContent"]> = {
    bottom: "flex-end",
    top: "flex-start"
};

export const MESSAGE_SCROLLER_SKELETON_ROWS = 3;

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignSelf: "center",
        width: "100%",
        flexGrow: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    stackBehaviour,
    shapeConfigs,
    spacerHeight,
    spaces
}: MessageScrollerContentDynamicStyleType) => {
    const styles = {
        container: {
            justifyContent: MESSAGE_SCROLLER_STACK_JUSTIFICATIONS[stackBehaviour],
            paddingBottom: spaces.spacingLg + spacerHeight,
            paddingHorizontal: spaces.spacingMd,
            maxWidth: shapeConfigs.chatWidth,
            paddingTop: spaces.spacingLg,
            gap: spaces.spacingLg
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
